export const CheckoutSteps = Object.freeze({
  Shipping: 1,
  Pickup: 1,
  Payment: 2,
  ReviewOrder: 3
})
